import firebase from "firebase/compat/app";
import "firebase/compat/database";
import ICharityEmailSetup from "../../types/ICharityEmailSetup";

export { default as ICharityEmailSetup } from "../../types/ICharityEmailSetup";

export const saveEmailSetupData = async (
  charityId: string,
  data: Partial<ICharityEmailSetup>
): Promise<void> => {
  if (!charityId) {
    throw new Error("Charity ID is required");
  }

  const database = firebase.database();
  const emailSetupRef = database.ref(`${charityId}/charitySetup/email`);

  const snapshot = await emailSetupRef.once('value');
  const existingData = snapshot.val() || {};

  const updatedData: Partial<ICharityEmailSetup> = {
    ...existingData,
    ...data,
    lastSaved: Date.now(),
  };

  await emailSetupRef.set(updatedData);
};

export const loadEmailSetupData = async (
  charityId: string
): Promise<ICharityEmailSetup | null> => {
  if (!charityId) {
    throw new Error("Charity ID is required");
  }

  const database = firebase.database();
  const emailSetupRef = database.ref(`${charityId}/charitySetup/email`);

  const snapshot = await emailSetupRef.once('value');
  return snapshot.val() || null;
};

export const determineStartingStep = (data: ICharityEmailSetup | null): { step: number } => {
  if (!data || !data.sendingDomain) {
    return { step: 0 };
  }

  if (data.sendingEmailsConfigured || data.sendingDomain.verified) {
    return { step: 2 };
  }

  if (data.sendingDomain.domain) {
    return { step: 1 };
  }

  return { step: 0 };
};
